import { useEffect, useState } from "react";
import { Button } from "@/components/Base/Button";
import { cn } from "@/lib/utils";
import { TimeOption } from "@/types/v2/ShopConfig";

export const DEFAULT_TIME_OPTIONS: TimeOption[] = [
  { label: "30m", value: 30 },
  { label: "1h", value: 60 },
  { label: "2h", value: 120 },
];

export type TimeUntilSelectorProps = {
  options?: TimeOption[];
  value?: number;
  onChange: (value: number) => void;
  className?: string;
  disabled?: boolean;
};

export const TimeUntilSelector = ({
  options = DEFAULT_TIME_OPTIONS,
  value,
  onChange,
  className,
  disabled,
}: TimeUntilSelectorProps) => {
  const [selectedValue, setSelectedValue] = useState<number | undefined>(value);

  // Update selectedValue when value prop changes
  useEffect(() => {
    if (value !== undefined) {
      setSelectedValue(value);
    }
  }, [value]);

  const handleSelect = (optionValue: number) => {
    setSelectedValue(optionValue);
    onChange(optionValue);
  };

  return (
    <div className={cn("flex flex-nowrap gap-2", className)}>
      {options.map((option) => (
        <Button
          key={option.value}
          type="button"
          variant={selectedValue === option.value ? "accent" : "outline"}
          onClick={() => handleSelect(option.value)}
          className="flex-1"
          size={"sm"}
          disabled={disabled}
        >
          {option.label}
        </Button>
      ))}
    </div>
  );
};
